import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import FileUploader from "../../../TCPForms/reusableComponents/FileUploader";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard } from "../../components/StyledComponent";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Col, Container, Row } from "react-bootstrap";
import DxfFileUploader from "../../reusableComponents/DxfFileUploader";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import axios from "axios";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@material-ui/core";

const Step2 = ({ formData, handleTabChange, tenantId }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  console.log("documentsFromReduxghjasd", documents, formData);
  const userInfo = Digit.UserService.getUser();
  const scrutinyFlow = formData?.scrutinyFlow === "PDF" || Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") === "PDF";
  const { t } = useTranslation();
  const isDA = formData?.department === "DA";
  const isLowRiskCase = formData?.riskType === "LOW";
  const isCompounding = formData?.applicationType === "FORM_COMPOUNDING";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const [noticeDocument, setNoticeDocument] = useState();
  const compensatoryFarDoc = Digit.SessionStorage.get("compensatoryFarDoc");
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const approvalLetterUrl = formData?.approvalLetterUrl;
  const showApprovedDocs =
    formData?.natureOfConstruction === "Revalidation/Time Extension" ||
    formData?.natureOfConstruction === "Addition Extension" ||
    formData?.natureOfConstruction === "Revision";
  const defaultValues = {
    ...formData,
    compoundingDrawingDxf: formData?.compoundingDrawingDxf || { fileStoreId: "", name: "" },
  };
  const isScheme = formData?.descriptionOfLand?.schemeType === "Scheme";
  const isSelfCert =
    formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const { handleSubmit, control, setValue, trigger, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset({
      ...formData,

      compoundingDrawingDxf: formData?.compoundingDrawingDxf?.fileStoreId ? formData?.compoundingDrawingDxf : file || { fileStoreId: "", name: "" },
    });
  }, [formData, documents, file, reset]);
  async function fetchLTPData() {
    const createdBy = userInfo?.info?.uuid;
    try {
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, { createdBy: createdBy });
      const ltpData = response?.Licenses?.filter((e) => e.status === "APPROVED") || [];
      console.log(response, ltpData, "ltpDataaaaaa");
      const regCert = ltpData?.[0]?.tradeLicenseDetail?.applicationDocuments?.filter((e) => e.documentType === "Registration Certificate") || [];
      const docs = [...regCert, ...formData.documents];

      // initFormMTDocs([...regCert, ...formData.documents]);
      const uniqueDocs = docs.filter(
        (doc, index, self) => index === self.findIndex((d) => d.documentType === doc.documentType && d.fileStoreId === doc.fileStoreId)
      );

      initFormMTDocs(uniqueDocs);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }

  // useEffect(() => {
  //   fetchLTPData();
  // }, []);

  useEffect(() => {
    if (file) {
      setValue("compoundingDrawingDxf", file);
    }
  }, [file]);

  const onChangeNoticeNo = async (vaadId) => {
    if (!vaadId) return;
    console.log("Fetching notice for Vaad ID:", vaadId);

    const url = `${Urls.bpaService.getNotice}${encodeURIComponent(vaadId)}`;

    const body = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: `${Date.now()}|en_IN`,
      },
    };

    try {
      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json, text/plain, */*",
        },
      });

      if (response?.data) {
        console.log("✅ Notice data fetched successfully:", response.data);
        const urls = response.data.noticeData.map((item) => item?.Url);
        setNoticeDocument(urls);
      } else {
        console.warn("No notice data found in the response.");
      }
    } catch (error) {
      console.error("Error fetching notice:", error);
    }
  };
  useEffect(() => {
    if (formData?.vaadId) {
      onChangeNoticeNo(formData?.vaadId);
    }
  }, [formData?.vaadId]);

  const onSubmit = (data) => {
    data = {
      ...data,
      nocDetails: formData?.nocDetails,
      documents: documents,
      compoundingDrawingDxf: file,
    };
    console.log("dataFromDocComponent", data);
    handleTabChange(2, data);
  };

  useEffect(() => {
    console.log("Notice Doc from Step2:", formData?.noticeDocument);
  }, [formData]);

  console.log("noticeDocument", formData?.noticeDocument);
  useEffect(() => {
    if (file) {
      setValue("compoundingDrawingDxf", file);
      handleTabChange(1, { compoundingDrawingDxf: file }); // 🔥 keeps it in parent state
    }
  }, [file]);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  console.log("formDataInStep2", formData, isCompounding);

  const handleOpenApprovalLetter = () => {
    if (approvalLetterUrl) {
      window.open(approvalLetterUrl, "_blank");
    }
  };

  const showSanctionDocs =
    formData?.natureOfConstruction !== "New" &&
    (formData?.natureOfConstruction !== "Compounding" || formData?.serviceType === "yes" || formData?.shortName === "yes");

  const isSanctionDocMandatory =
    formData?.natureOfConstruction !== "Redevelopment/Reconstruction" && formData?.natureOfConstruction !== "Redevelopment";

  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        {showSanctionDocs && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Sanction Documents")}</h2>
            </div>

            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Previous Sanction Map")}
                      control={control}
                      name="Previous Sanction Map"
                      validationMsg="Upload File"
                      required={isSanctionDocMandatory}
                      isMandatory={isSanctionDocMandatory}
                      trigger={trigger}
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Previous Sanction Letter")}
                      control={control}
                      name="Previous Sanction Letter"
                      validationMsg="Upload File"
                      required={isSanctionDocMandatory}
                      isMandatory={isSanctionDocMandatory}
                      trigger={trigger}
                    />
                  </Col>
                  <Col md={12}>
                    <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB){isSanctionDocMandatory ? "*" : ""}</div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        )}
        {formData?.natureOfConstruction === "Compounding" && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Compounding Documents")}</h2>
            </div>

            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Compounding Drawing PDF")}
                      control={control}
                      name="drawingPdf"
                      validationMsg="Upload File"
                      required
                      tab={"pdf"}
                      trigger={trigger}
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Compounding drawing dwg")}
                      control={control}
                      name="compoundingDrawingDxf"
                      validationMsg="Upload File"
                      trigger={trigger}
                      tab={3}
                      setFile={setFile}
                      required
                      isMandatory
                    />
                  </Col>
                  {/* <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Site Photo")}
                      control={control}
                      name="uptodatePaymentLetter"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col> */}
                  {formData?.isAncestralProperty === "In response to notice" && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Upload Notice")}
                        control={control}
                        name="responseNotice"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {noticeDocument?.length > 0 && (
                    <Col md={6}>
                      <strong>Notice Document:</strong>{" "}
                      {noticeDocument.map((url, index) => (
                        <ul key={index}>
                          <li>
                            <a
                              href={url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                            >
                              Download Notice Document{index + 1}
                            </a>
                          </li>
                        </ul>
                      ))}
                    </Col>
                  )}

                  {/* {isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Owner Affidavit")}
                        control={control}
                        name="ltpAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )} */}
                  <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                </Row>
              </div>
            </div>
          </div>
        )}
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Mandatory Documents")}</h2>
          </div>

          <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
            <div className="columnWrapper">
              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader
                    label={t("Architect/Engineer Registration Certificate")}
                    control={control}
                    name="Registration Certificate"
                    validationMsg="Upload File"
                    required
                    isMandatory
                    trigger={trigger}
                  />
                </Col>

                {!isLowRiskCase && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Calculation sheet of Estimate with Affidavit")}
                      control={control}
                      name="calculationSheet"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                )}
                {/* {!isLowRiskCase ||
                  (!isCompounding && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Drawing PDF")}
                        control={control}
                        name="drawingPdf"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  ))} */}

                {!isScheme && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Khatauni")}
                      control={control}
                      name="khatauni"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                )}

                {!isSelfCert && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Owner Affidavit")}
                      control={control}
                      name="ownerAffidavit"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                )}
                {/* {isSelfCert && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Drawing Pdf")}
                      control={control}
                      name="drawingPDF"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                )} */}

                {isScheme && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      control={control}
                      label={t("Allotment Letter/Possession Letter")}
                      name="allotmentLetterPossessionLetter"
                      validationMsg="Upload File"
                      required
                      maxFiles={4}
                      trigger={trigger}
                    />
                  </Col>
                )}
                <Col md={6}>
                  <FileUploader
                    label={t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement")}
                    control={control}
                    name="registrySaleDeedHPTA"
                    isMandatory
                    validationMsg="Upload File"
                    required
                    trigger={trigger}
                  />
                </Col>
                {compensatoryFarDoc && (
                  <Col md={6}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <strong>Compensatory FAR Document : </strong>
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "30px", cursor: "pointer" }}
                        onClick={() => getDocumentByFileStoreId(compensatoryFarDoc, setLoader, false)}
                      />
                    </div>
                  </Col>
                )}
                {/* {isScheme && <FileUploader
                                isMandatory
                                label={t("Possession Letter")}
                                control={control}
                                name="possessionLetter"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />} */}
                {isSelfCert && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("LTP Affidavit")}
                      control={control}
                      name="ltpAffidavit"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                )}

                {!isScheme && (
                  <Col md={6}>
                    <FileUploader
                      label={t("Developer/Consortium/Sales Agreement")}
                      control={control}
                      name="developerConsortiumSalesAgreement"
                      validationMsg="Upload File"
                      trigger={trigger}
                    />
                  </Col>
                )}
                {!isDA && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Upto date payment letter")}
                      control={control}
                      name="uptodatePaymentLetter"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                )}
                {scrutinyFlow && !isCompounding && (
                  <Col md={6}>
                    <FileUploader
                      label={t("Dwg drawing")}
                      control={control}
                      name="dxfDrawing"
                      isMandatory
                      required
                      validationMsg="Upload File"
                      trigger={trigger}
                      tab={3}
                    />
                  </Col>
                )}
                {!isScheme && (
                  <Col md={6}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <strong>Approval Letter:</strong>
                      <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px", cursor: "pointer" }} onClick={handleOpenApprovalLetter} />
                    </div>
                  </Col>
                )}

                <Col md={6}>
                  <FileUploader
                    isMandatory
                    label={t("Fire Affidavit")}
                    control={control}
                    name="fireAffidavit"
                    validationMsg="Upload File"
                    required
                    trigger={trigger}
                  />
                </Col>

                <Col md={6}>
                  <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                </Col>
                {(!isLowRiskCase && !isCompounding) ||
                  (isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        tab={"pdf"}
                        label={t("Drawing Pdf")}
                        control={control}
                        name="drawingPdf"
                        validationMsg="Upload File"
                        trigger={trigger}
                      />
                    </Col>
                  ))}
                {formData?.edcrNumber ? (
                  <Grid container spacing={2} style={{ padding: "1rem" }}>
                    <Grid item xs={6}>
                      <strong>{"Drawing Pdf"} </strong>:
                    </Grid>
                    <Grid item xs={6}>
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "30px" }}
                        onClick={() => window.open(formData?.updatedDxfFile, "_blank")}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <Col md={6}>
                    <FileUploader
                      label={t("Drawing Pdf")}
                      isMandatory
                      required
                      tab={"pdf"}
                      control={control}
                      name="drawingPdf"
                      validationMsg="Upload File"
                      trigger={trigger}
                    />
                  </Col>
                )}
              </Row>

              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader
                    isMandatory
                    label={t("Site Photo")}
                    control={control}
                    name="sitePhoto"
                    validationMsg="Upload File"
                    required
                    maxFiles={4}
                    tab={2}
                    trigger={trigger}
                  />
                </Col>
                <Col md={12}>
                  <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                </Col>
              </Row>

              {/* <FileUploader
                                isMandatory
                                label={t("Common Affidavit")}
                                control={control}
                                name="commonAffidavit"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            /> */}

              {/* <FileUploader
                                isMandatory
                                label={t("Owner Affidavit")}
                                control={control}
                                name="ownerAffidavit"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            /> */}

              {/* {!isScheme && <FileUploader
                                isMandatory
                                label={t("Mutation Letter")}
                                control={control}
                                name="mutationLetter"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />} */}
            </div>
          </div>
        </div>
        {showApprovedDocs && (
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <strong>Approved Certificate</strong>:
                  </Grid>{" "}
                  {/* Label part */}
                  <Grid item xs={6}>
                    {formData?.approvalCertificateUrl ? (
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "30px", cursor: "pointer" }}
                        onClick={() => window.open(formData?.approvalCertificateUrl, "_blank")}
                      />
                    ) : (
                      <FaFilePdf color="#00000057" style={{ width: "20px", height: "30px" }} />
                    )}
                  </Grid>
                </Grid>
              </Col>
              <Col>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <strong>Approved Letter</strong>:
                  </Grid>{" "}
                  {/* Label part */}
                  <Grid item xs={6}>
                    {formData?.approvalLetterUrl ? (
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "30px", cursor: "pointer" }}
                        onClick={() => window.open(formData?.approvalLetterUrl, "_blank")}
                      />
                    ) : (
                      <FaFilePdf color="#00000057" style={{ width: "20px", height: "30px" }} />
                    )}
                  </Grid>
                </Grid>
              </Col>
            </Row>
          </Container>
        )}
        {/* <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Conditional Documents")}</h2>
          </div>

          <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
            <div className="columnWrapper">
              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader label={t("Structural Audit Report")} control={control} name="structuralAuditReport" validationMsg="Upload File" />
                </Col>

                <Col md={6}>
                  <FileUploader label={t("Additional Document if any")} control={control} name="additionalDoc" validationMsg="Upload File" />
                </Col>

                <Col md={6}>
                  <FileUploader label={t("Structural Drawing and Design ")} control={control} name="structuraldrawing" validationMsg="Upload File" />
                </Col>

                <Col md={6}>
                  <FileUploader
                    label={t("Structural Stability Certificate")}
                    control={control}
                    name="structuralcertificate"
                    validationMsg="Upload File"
                  />
                </Col>

                <Col md={6}>
                  <FileUploader
                    label={t("Structural Design calculation Report")}
                    control={control}
                    name="calculationReport"
                    validationMsg="Upload File"
                  />
                </Col>
                <Col md={6}>
                  <FileUploader
                    control={control}
                    label={t("Vetted Structure and drawing along with certificate")}
                    name="vettedStructure"
                    validationMsg="Upload File"
                  />
                </Col>

                <Col md={6}>
                  <FileUploader
                    label={t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer.")}
                    control={control}
                    name="annexture789"
                    validationMsg="Upload File"
                  />
                </Col>
                {isDA && (
                  <Col md={6}>
                    <FileUploader label={t("Upto date payment letter")} control={control} name="uptodatePaymentLetter" validationMsg="Upload File" />
                  </Col>
                )}
                <Col md={12}>
                  <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                </Col>
              </Row>
              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader label={t("Approved Layout sanctioned Letter")} control={control} name="sanctionLetter" validationMsg="Upload File" />
                </Col>

                <Col md={12}>
                  <div className="text-red important-note">Note: (Allowed Format .pdf)*</div>
                </Col>
              </Row>
            </div>
          </div>
        </div> */}

        {/* <Accordion className="formContainer" defaultExpanded={false}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className="custom-accordion-header">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Conditional Documents")}</h2>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader label={t("Structural Audit Report")} control={control} name="structuralAuditReport" validationMsg="Upload File" />
                  </Col>

                  <Col md={6}>
                    <FileUploader label={t("Additional Document if any")} control={control} name="additionalDoc" validationMsg="Upload File" />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Drawing and Design ")}
                      control={control}
                      name="structuraldrawing"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Stability Certificate")}
                      control={control}
                      name="structuralcertificate"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Design calculation Report")}
                      control={control}
                      name="calculationReport"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      control={control}
                      label={t("Vetted Structure and drawing along with certificate")}
                      name="vettedStructure"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer.")}
                      control={control}
                      name="annexture789"
                      validationMsg="Upload File"
                    />
                  </Col>

                  {isDA && (
                    <Col md={6}>
                      <FileUploader
                        label={t("Upto date payment letter")}
                        control={control}
                        name="uptodatePaymentLetter"
                        validationMsg="Upload File"
                      />
                    </Col>
                  )}

                  <Col md={12}>
                    <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                  </Col>
                </Row>

                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Approved Layout sanctioned Letter")}
                      control={control}
                      name="sanctionLetter"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={12}>
                    <div className="text-red important-note">Note: (Allowed Format .pdf)*</div>
                  </Col>
                </Row>
              </div>
            </div>
          </AccordionDetails>
        </Accordion> */}

        <div className="formContainer">
          <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
            {/* HEADER NOW INSIDE BLUE AREA */}
            <div
              className="formHeaderContainer"
              onClick={() => setOpen((prev) => !prev)}
              style={{
                cursor: "pointer",
                position: "relative",
              }}
            >
              <h2 className="formHeading">{t("Conditional Documents")}</h2>

              <ExpandMoreIcon
                style={{
                  position: "absolute",
                  right: "16px",
                  top: "50%",
                  transform: open ? "translateY(-50%) rotate(180deg)" : "translateY(-50%) rotate(0deg)",
                  transition: "0.3s",
                }}
              />
            </div>

            {/* Collapsible Content */}
            {open && (
              <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
                <div className="columnWrapper">
                  <Row className="inner-mini-wrapper">
                    <Col md={6}>
                      <FileUploader label={t("Structural Audit Report")} control={control} name="structuralAuditReport" validationMsg="Upload File" />
                    </Col>

                    <Col md={6}>
                      <FileUploader label={t("Additional Document if any")} control={control} name="additionalDoc" validationMsg="Upload File" />
                    </Col>

                    <Col md={6}>
                      <FileUploader
                        label={t("Structural Drawing and Design")}
                        control={control}
                        name="structuraldrawing"
                        validationMsg="Upload File"
                      />
                    </Col>

                    <Col md={6}>
                      <FileUploader
                        label={t("Structural Stability Certificate")}
                        control={control}
                        name="structuralcertificate"
                        validationMsg="Upload File"
                      />
                    </Col>

                    <Col md={6}>
                      <FileUploader
                        label={t("Structural Design calculation Report")}
                        control={control}
                        name="calculationReport"
                        validationMsg="Upload File"
                      />
                    </Col>

                    <Col md={6}>
                      <FileUploader
                        label={t("Vetted Structure and drawing along with certificate")}
                        control={control}
                        name="vettedStructure"
                        validationMsg="Upload File"
                      />
                    </Col>

                    <Col md={6}>
                      <FileUploader
                        label={t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer.")}
                        control={control}
                        name="annexture789"
                        validationMsg="Upload File"
                      />
                    </Col>

                    {isDA && (
                      <Col md={6}>
                        <FileUploader
                          label={t("Upto date payment letter")}
                          control={control}
                          name="uptodatePaymentLetter"
                          validationMsg="Upload File"
                        />
                      </Col>
                    )}

                    <Col md={12}>
                      <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                    </Col>
                  </Row>

                  <Row className="inner-mini-wrapper">
                    <Col md={6}>
                      <FileUploader
                        label={t("Approved Layout sanctioned Letter")}
                        control={control}
                        name="sanctionLetter"
                        validationMsg="Upload File"
                      />
                    </Col>

                    <Col md={12}>
                      <div className="text-red important-note">Note: (Allowed Format .pdf)*</div>
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Add */}
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(0)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
